import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownOptions } from 'src/app/models/dropdown-options';
import { UserExamRecord } from 'src/app/models/userExamRecord.model';

@Component({
  selector: 'app-exam-record-dialog',
  standalone: true,
  imports: [
    ButtonModule,
    DropdownModule,
    FloatLabelModule,
    ReactiveFormsModule,
    InputNumberModule,
  ],
  templateUrl: './exam-record-dialog.component.html',
  styleUrl: './exam-record-dialog.component.scss',
})
export class ExamRecordDialogComponent implements OnInit {
  @Input() userId: number;
  @Input() examTypes: DropdownOptions[];
  @Output() dialogClosed = new EventEmitter<UserExamRecord | null>();

  constructor(private fb: FormBuilder) {}

  form: FormGroup;

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      examType: new FormControl('', Validators.required),
      examResult: new FormControl(null, Validators.required),
    });
  }

  resetForm() {
    this.form.reset();
  }

  submit() {
    if (this.form.valid) {
      const result: UserExamRecord = {
        userId: this.userId,
        examType: this.form.value.examType,
        examResult: this.form.value.examResult,
      };
      this.resetForm();
      this.dialogClosed.emit(result);
    }
  }

  cancel() {
    this.resetForm();
    this.dialogClosed.emit(null);
  }
}
